export const PERMS = {
    READ: 'vehicle_types.read',
    UPDATE: 'vehicle_types.update',
    DELETE: 'vehicle_types.delete',
    CREATE: 'vehicle_types.create',
    EXPORT: 'vehicle_types.export',
}
